/**
 * Presentation helpers for the activated native cart.
 * Shipping amounts come from Liquid-replaced markup. No fetch patch. No Rebuy.
 */
(function (root) {
  if (root.NativeCartPresentation) return;

  function readPublicConfig() {
    if (typeof document === 'undefined') return { enabled: false };
    var node = document.getElementById('NativeCartPublicConfig');
    if (!node || !node.textContent) return { enabled: false };
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return { enabled: false, reason: 'malformed_json' };
    }
  }

  function rewriteCartQtySurface(root, surface) {
    if (!root || !root.querySelectorAll) return;
    var qtySurface = surface === 'page' ? 'cart_page' : surface;
    if (qtySurface !== 'cart_page' && qtySurface !== 'cart_drawer') {
      qtySurface = 'cart_drawer';
    }
    root.querySelectorAll('.js-qty__wrapper').forEach(function (wrap) {
      var input = wrap.querySelector('.js-qty__num');
      var label = wrap.querySelector('label[for]');
      if (!input) return;
      var key = input.getAttribute('data-id');
      if (!key) return;
      var nextId = 'cart_updates_' + qtySurface + '_' + key;
      input.id = nextId;
      if (label) label.setAttribute('for', nextId);
    });
  }

  function rewriteSurface(node, surface) {
    if (!node || !node.querySelectorAll) return;
    var giftSurface = surface === 'page' ? 'cart_page' : surface;
    if (giftSurface === 'cart_page') {
      node.querySelectorAll('[data-caffeine-gift-box]').forEach(function (offer) {
        offer.setAttribute('data-surface', 'cart_page');
      });
      node.querySelectorAll('[id]').forEach(function (el) {
        if (el.id && el.id.indexOf('cart_drawer') !== -1) {
          el.id = el.id.split('cart_drawer').join('cart_page');
        }
      });
      node.querySelectorAll('[for]').forEach(function (el) {
        var attr = el.getAttribute('for');
        if (attr && attr.indexOf('cart_drawer') !== -1) {
          el.setAttribute('for', attr.split('cart_drawer').join('cart_page'));
        }
      });
      node.querySelectorAll('[form]').forEach(function (el) {
        var formId = el.getAttribute('form');
        if (formId && formId.indexOf('cart_drawer') !== -1) {
          el.setAttribute('form', formId.split('cart_drawer').join('cart_page'));
        }
      });
    }
    var shippingSurface = surface === 'cart_page' ? 'page' : surface;
    node.querySelectorAll('[data-native-cart-shipping]').forEach(function (el) {
      el.classList.remove('native-cart-shipping--drawer', 'native-cart-shipping--page');
      el.classList.add('native-cart-shipping--' + shippingSurface);
      el.setAttribute('data-native-cart-surface', shippingSurface);
    });
  }

  function offerTargets(rootEl, name) {
    return rootEl.querySelectorAll(
      '[data-native-cart-slot="' + name + '"], [data-native-cart-offer="' + name + '"]'
    );
  }

  function clearDisabledOffer(rootEl, name) {
    offerTargets(rootEl, name).forEach(function (slot) {
      slot.innerHTML = '';
    });
    var stray = {
      giftBox: '[data-caffeine-gift-box]',
      recommendations: '[data-native-cart-recommendations], [data-caffeine-recommendations]',
      shipping: '[data-native-cart-shipping]'
    }[name];
    if (!stray) return;
    rootEl.querySelectorAll(stray).forEach(function (el) {
      el.remove();
    });
  }

  function applyRefreshSlots(rootEl, parsedRoot) {
    if (!rootEl || !parsedRoot || !parsedRoot.querySelectorAll) return false;
    var names = ['shipping', 'giftBox', 'recommendations'];
    var applied = false;
    names.forEach(function (name) {
      var next = parsedRoot.querySelector('[data-native-cart-refresh="' + name + '"]');
      if (!next) return;
      if (next.getAttribute('data-native-cart-refresh-state') === 'off') {
        clearDisabledOffer(rootEl, name);
        applied = true;
        return;
      }
      var slots = offerTargets(rootEl, name);
      if (!slots.length) return;
      slots.forEach(function (slot) {
        var surface = slot.getAttribute('data-native-cart-surface') || '';
        slot.innerHTML = next.innerHTML;
        rewriteSurface(slot, surface);
      });
      applied = true;
    });
    return applied;
  }

  function syncShippingFills(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-native-cart-shipping]').forEach(function (node) {
      var ratio = 0;
      var state = node.getAttribute('data-state');
      if (state === 'reached') {
        ratio = 1;
      } else if (state === 'below') {
        var threshold = Number(node.getAttribute('data-threshold')) || 0;
        var qualifying = Number(node.getAttribute('data-qualifying')) || 0;
        ratio = threshold > 0 ? Math.max(0, Math.min(1, qualifying / threshold)) : 0;
      }
      node.style.setProperty('--native-cart-progress', String(ratio));
    });
  }

  function init() {
    var config = readPublicConfig();
    if (!config || config.enabled !== true) return;
    if (typeof document === 'undefined') return;
    syncShippingFills(document);
    document.addEventListener('caffeine:cart:changed', function () {
      syncShippingFills(document);
    });
  }

  var api = {
    readPublicConfig: readPublicConfig,
    applyRefreshSlots: applyRefreshSlots,
    rewriteSurface: rewriteSurface,
    rewriteCartQtySurface: rewriteCartQtySurface,
    syncShippingFills: syncShippingFills
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  root.NativeCartPresentation = api;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
